import { useEffect } from "react";

const VMFWidget = () => {
    useEffect(() => {
        // Check if the script is already added
        if (!document.querySelector('script[src="https://portal-widgets.lsqportal.com/assets/bootstrap-widget.js"]')) {
            const script = document.createElement('script');
            script.src = 'https://portal-widgets.lsqportal.com/assets/bootstrap-widget.js';
            script.setAttribute('data-widget-id', '783a8cfe-cd8a-11ef-b491-02eda0793197');
            script.setAttribute('data-version-id', '8cf07ede-dbba-4740-8dcb-3d2d2da86b97');
            script.setAttribute('data-formjs', 'https://forms.lsqportal.com/r21/js/lsq.form.js');
            script.setAttribute('data-URL', 'https://portal-widgets.lsqportal.com');
            script.setAttribute('onload', "window['___lsq-portal-widget-helpers___'].bootstrapLSQWidget(event)");
            script.Charset = 'utf-8';
        
            // Append the script to the div with id "sd"
            const widgetDiv = document.getElementById('lsq-portal-widget-783a8cfe-cd8a-11ef-b491-02eda0793197-8cf07ede-dbba-4740-8dcb-3d2d2da86b97');
            if (widgetDiv) {
                widgetDiv.appendChild(script);
            }
        }
    }, []);
    
    return (
        <div id="lsq-portal-widget-783a8cfe-cd8a-11ef-b491-02eda0793197-8cf07ede-dbba-4740-8dcb-3d2d2da86b97" className="lsq-portal-widget lsq-form-widget">
        </div>
    );
}
export default VMFWidget;